import React from 'react'
import { FormattedAddress } from 'utilities'
import "components/FilingDetail/FilingDetail.scss"

export const DetailBlock = ({children, title=''}) => (
  <div className='detail-block'>
    <div className='title'>{title}</div>
    <div className='details'>
      {children}
    </div>
  </div>
)

export class Detail extends React.Component{
  formatValueByType = () => {
    const { value, type } = this.props;
    switch (type) {
      case 'address':
        return <FormattedAddress value={value} />
      default:
        return value
    }
  }
  render(){
    const {label, value, nullValue=''} = this.props;
    return(
      <div className='detail-wrapper'>
        <label>{label}</label>
        <span className='value'>{value ? this.formatValueByType() : nullValue}</span>
      </div>
    )
  }
}

export const StackedLabel = ({primary, secondary}) => (
  <div className='stacked-label'>
    <span className='primary'>{primary}</span>
    <span className='secondary'>{secondary}</span>
  </div>
)
